import React from 'react';
import './Contact.css';

const CONTACT_INFO = {
  phone: "5521966527607",
  message: "Olá! Tenho interesse nos serviços da Brilha Piscina. Gostaria de solicitar um orçamento."
};

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2>Entre em <span className="highlight">Contato</span></h2>
          <p>
            Visite nossa loja ou entre em contato conosco através dos nossos 
            canais de atendimento. Estamos sempre prontos para ajudar!
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon">📞</div>
              <div className="contact-details">
                <h3>Telefone</h3>
                <p>(21) 96652-7607</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">✉️</div>
              <div className="contact-details">
                <h3>E-mail</h3>
                <p>brilhapiscina@gmail.com</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">📍</div>
              <div className="contact-details">
                <h3>Localização</h3>
                <p>Estrada dos Três Rios, Nº 480</p>
                <p>Freguesia de Jacarepaguá - Rio de Janeiro</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">⏰</div>
              <div className="contact-details">
                <h3>Horário de Atendimento</h3>
                <p>Segunda a Sexta: 8h às 18h</p>
                <p>Sábado: 8h às 15h</p>
              </div>
            </div>
          </div>

          <div className="contact-map">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3674.3224215626387!2d-43.34160132468869!3d-22.93834997923295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9bd9b4b6b91dd3%3A0x5076ccce75d643bb!2sBRILHA%20PISCINA!5e0!3m2!1spt-BR!2sbr!4v1772221342724!5m2!1spt-BR!2sbr" 
              width="100%" 
              height="450" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa da Brilha Piscina"
            ></iframe>
          </div>
        </div>
        {/* Novo botão de WhatsApp na seção de contato */}
        <div className="contact-cta-wrapper">
          <p className="contact-warning-text">
            <strong>Cada dia com a piscina parada pode gerar mais prejuízo. Resolva agora.</strong>
          </p>
          <div className="contact-cta-button">
            <a 
              href={`https://wa.me/${CONTACT_INFO.phone}?text=${encodeURIComponent(CONTACT_INFO.message)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary-contact" /* Nova classe para o botão de contato */
            >
              CHAME NO WHATSAPP AGORA!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
